import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IdiomaCatalogo } from '../../model/catalogo.model';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Poliza, Riesgo } from '../../model/poliza.model';
import { CaError, CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { CaSelectComponent } from '@global-front-components/ui/select';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-idiomas',
	standalone: true,
	imports: [		
		CommonModule,
		CaFormFieldComponent,
		ReactiveFormsModule,		
		CaSelectComponent, 
		CaError,
		TranslateModule,
		CaLabel
	],
	templateUrl: './idiomas.component.html',
	styleUrls: ['./idiomas.component.scss']
})
export class IdiomasComponent {
	@Input() idiomas: IdiomaCatalogo[] = [];
	@Input() form: FormGroup;
	@Input() poliza: Poliza<Riesgo> = {};

	constructor(private fb: FormBuilder){}

	ngOnInit(): void {
		if (!this.form) {
			this.form = this.fb.group({});
		}
		this.buildForm();
	}

	buildForm(): void {
		const idiomaDefectoCatalogo = this.idiomas.find(idioma => idioma.valorDefecto ===true);
		const codigoIdioma = this.poliza?.codigoIdioma ?? idiomaDefectoCatalogo?.codigoIdioma ?? '';
		this.form.addControl('codIdioma', this.fb.control(codigoIdioma, [Validators.required]));
	}
}
